import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from "@angular/forms";
import { firstValueFrom, from, mergeMap, Subject, takeUntil, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
    selector: 'email-template',
    templateUrl: './email-templates.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailTemplatesComponent implements OnInit, OnDestroy {

    protected templates = [
        {label: 'Mood email', url: '/admin/dailyEmail', options: []},
        {label: 'Digest email', url: '/admin/digestEmail', options: []},
        {
            label: 'Mood commented email',
            url: '/admin/moodCommentedEmail',
            options: ['contributor', 'author']
        },
        {
            label: 'Mood streak commented email',
            url: '/admin/moodStreakCommentedEmail',
            options: ['contributor', 'author']
        },
        {
            label: 'Topic commented email',
            url: '/admin/topicCommentedEmail',
            options: ['contributor', 'author']
        },
        {label: 'Topic created email', url: '/admin/topicCreatedEmail', options: []},
        {label: 'Kudos created email', url: '/admin/kudosCreatedEmail', options: []},
        {
            label: 'Kudos commented email',
            url: '/admin/kudosCommentedEmail',
            options: ['contributor', 'author']
        },
        {label: 'Mentioned in review', url: '/admin/mentionedInReviewEmail', options: ['contributor', 'author']},
        {label: 'Ask for more comment', url: '/admin/askForMoreCommentsEmail', options: []},
        {
            label: 'Question reminder email',
            url: '/admin/questionReminderEmail',
            options: ['five-stars', 'agree-disagree', 'closed', 'scale']
        },
        {
            label: 'Nudge email',
            url: '/admin/nudgeEmail',
            options: ['ShareMoodNudge', 'AskQuestionNudge', 'SendKudosNudge', 'EncourageToCommentMore', 'EncourageAdminToCommentMore', 'EncourageManagersToCreateAPoll']
        },
        {label: 'Assignment', url: '/admin/assignmentEmail', options: []},
    ];

    protected brandingCtrl = new FormControl<string>('teammood-branding');
    protected brandings: string[] = []

    protected url: string = '/admin/dailyEmail';
    protected options: string[];

    protected html: SafeHtml;

    private selectedOption: string = '';

    private _destroy$ = new Subject<void>();

    constructor(
        private httpClient: HttpClient,
        private sanitizer: DomSanitizer,
    ) {
    }

    async ngOnInit() {

        this.httpClient.get<string[]>('/admin/brandings')
            .pipe(
                tap(brandings => {
                    this.brandings = brandings;
                }),
                takeUntil(this._destroy$),
            )
            .subscribe();

        this.brandingCtrl.valueChanges.pipe(
            mergeMap(() => {
                return from(this.render());
            }),
            takeUntil(this._destroy$),
        ).subscribe();

        await this.render();
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    async renderEmail(url: string, options: string[]) {

        this.url = url;
        this.options = options;

        this.selectedOption = options[0] || '';

        await this.render();
    }

    protected async setOption(option: string) {
        this.selectedOption = option;

        await this.render();
    }

    private async render() {
        this.html = this.sanitizer.bypassSecurityTrustHtml(
            await firstValueFrom(
                this.httpClient.get(this.url, {
                    responseType: 'text',
                    params: {'option': this.selectedOption, branding: this.brandingCtrl.getRawValue()}
                }),
            )
        );
    }
}